import { Component, OnInit, ViewChild, OnChanges, Input } from "@angular/core";
import { NgbModalRef, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { LoaderService } from "src/app/services/loader.service";
import { ArchivoCoordenadaService } from "src/app/services/archivo-coordenada.service";
import { take, tap } from "rxjs/operators";
import { ArchivoCoordenada } from "src/app/models/entities/archivo-coordenada";
import { LevantamientoObra } from "src/app/models/entities/levantamiento-obra";
import { CatalogoService } from "src/app/services/catalogo.service";
import { RutaCatalogoEnum } from "src/app/shared/enums/ruta-catalogo.enum";
import { Estado } from "src/app/models/entities/estado";
import { LevantamientoObraService } from "src/app/services/levantamiento-obra.service";
import * as jsPDF from "jspdf";
import { PdfUtils } from "src/app/shared/utils/pdf-utils";

@Component({
  selector: "modal-reporte-fotografico",
  templateUrl: "./modal-reporte-fotografico.component.html",
  styleUrls: ["./modal-reporte-fotografico.component.scss"],
})
export class ModalReporteFotograficoComponent implements OnInit, OnChanges {
  @ViewChild("modalReporteFotografico")
  public modalReporteFotografico: any;
  public modalActivo: NgbModalRef;
  public archivos: ArchivoCoordenada[];
  public imagenesCapaCompletado: ArchivoCoordenada[];
  public imagenesCapaMetaActual: ArchivoCoordenada[];
  public imagenesCapaEstructura: ArchivoCoordenada[];
  public KEY_CAPA_META_ACTUAL: number = 1;
  public KEY_CAPA_COMPLETADO: number = 2;
  public KEY_CAPA_ESTRUCTURA: number = 5;
  public NUMERO_FOTOS_POR_CAPA: number = 16;
  public estados: Estado[] = [];
  public nombreEstado: string = "";
  public nombreObra: string = "";
  constructor(
    private modalService: NgbModal,
    private loaderScreenService: LoaderService,
    private archivoCoordenadaService: ArchivoCoordenadaService,
    private catalogoService: CatalogoService,
    private levantamientoObraService: LevantamientoObraService,
    private pdfUtils: PdfUtils
  ) {}

  async ngOnChanges(): Promise<any> {}

  public async ngOnInit() {
    this.estados = await this.catalogoService
      .obtenerCatalogo<Estado>(RutaCatalogoEnum.ESTADOS)
      .pipe(take(1))
      .toPromise();
  }

  public async descargarPDF(): Promise<void> {
    this.loaderScreenService.activarLoaderScreen();

    let promesasImagenesCompletado: Promise<string>[] =
      this.imagenesCapaCompletado.map((archivo: ArchivoCoordenada) => {
        return new Promise<string>((resolve, err) => {
          let img = new Image();
          img.crossOrigin = "Anonymous";
          img.onload = () => {
            let canvas = document.createElement("canvas");
            let ctx = canvas.getContext("2d");
            canvas.height = img.naturalHeight;
            canvas.width = img.naturalWidth;
            ctx.drawImage(img, 0, 0);
            let uri = canvas.toDataURL("image/png");
            let b64: string = uri.replace(/^data:image.+;base64,/, "");
            resolve(b64);
          };
          let url: string = archivo.urlDescarga;
          img.src = url;
        });
      });

    let promesasImagenesMeta: Promise<string>[] =
      this.imagenesCapaMetaActual.map((archivo: ArchivoCoordenada) => {
        return new Promise<string>((resolve, err) => {
          let img = new Image();
          img.crossOrigin = "Anonymous";
          img.onload = () => {
            let canvas = document.createElement("canvas");
            let ctx = canvas.getContext("2d");
            canvas.height = img.naturalHeight;
            canvas.width = img.naturalWidth;
            ctx.drawImage(img, 0, 0);
            let uri = canvas.toDataURL("image/png");
            let b64: string = uri.replace(/^data:image.+;base64,/, "");
            resolve(b64);
          };
          let url: string = archivo.urlDescarga;
          img.src = url;
        });
      });

    let promesasImagenesEstructuras: Promise<string>[] =
      this.imagenesCapaEstructura.map((archivo: ArchivoCoordenada) => {
        return new Promise<string>((resolve, err) => {
          let img = new Image();
          img.crossOrigin = "Anonymous";
          img.onload = () => {
            let canvas = document.createElement("canvas");
            let ctx = canvas.getContext("2d");
            canvas.height = img.naturalHeight;
            canvas.width = img.naturalWidth;
            ctx.drawImage(img, 0, 0);
            let uri = canvas.toDataURL("image/png", 1.0);
            let b64: string = uri.replace(/^data:image.+;base64,/, "");
            resolve(b64);
          };
          let url: string = archivo.urlDescarga;
          img.src = url;
        });
      });

    let logoBase64: string = await new Promise<string>((resolve, err) => {
      let img = new Image();
      img.crossOrigin = "Anonymous";
      img.onload = () => {
        let canvas = document.createElement("canvas");
        let ctx = canvas.getContext("2d");
        canvas.height = img.naturalHeight;
        canvas.width = img.naturalWidth;
        ctx.drawImage(img, 0, 0);
        let uri = canvas.toDataURL("image/png", 1.0);
        let b64: string = uri.replace(/^data:image.+;base64,/, "");
        resolve(b64);
      };
      let url: string = "../../../../../assets/img/logo3.png";
      img.src = url;
    });

    let base64ImagenesCompletado: string[] = await Promise.all(
      promesasImagenesCompletado
    );
    let base64ImagenesMeta: string[] = await Promise.all(promesasImagenesMeta);
    let base64ImagenesEstructura: string[] = await Promise.all(
      promesasImagenesEstructuras
    );

    this.pdfUtils.descargarReporteFotografico(
      this.nombreEstado,
      this.nombreObra,
      logoBase64,
      this.imagenesCapaCompletado,
      this.imagenesCapaMetaActual,
      this.imagenesCapaEstructura,
      base64ImagenesCompletado,
      base64ImagenesMeta,
      base64ImagenesEstructura
    );
  }

  public async abrirModal(keyLevantamientoObra: string): Promise<void> {
    this.archivos = [];
    this.imagenesCapaCompletado = [];
    this.imagenesCapaMetaActual = [];
    let levantamientoObra: LevantamientoObra =
      await this.levantamientoObraService
        .findByKey(keyLevantamientoObra)
        .pipe(take(1))
        .toPromise();
    this.nombreEstado = this.estados.find(
      (e: Estado) => e.key === levantamientoObra.keyCatEstado
    ).nombre;
    this.nombreObra = levantamientoObra.nombreObra;
    this.archivos = await this.archivoCoordenadaService
      .findByKeyLevantamientoObra(keyLevantamientoObra)
      .pipe(take(1))
      .toPromise();
    this.imagenesCapaMetaActual = this.archivos
      .filter(
        (archivo: ArchivoCoordenada) =>
          archivo.tipo === "imagen" &&
          archivo.keyCatCapa === this.KEY_CAPA_META_ACTUAL
      )
      .sort(
        (a: ArchivoCoordenada, b: ArchivoCoordenada) =>
          b.fechaCreacion - a.fechaCreacion
      )
      .reverse()
      .slice(0, this.NUMERO_FOTOS_POR_CAPA);
    this.imagenesCapaCompletado = this.archivos
      .filter(
        (archivo: ArchivoCoordenada) =>
          archivo.tipo === "imagen" &&
          archivo.keyCatCapa === this.KEY_CAPA_COMPLETADO
      )
      .sort(
        (a: ArchivoCoordenada, b: ArchivoCoordenada) =>
          b.fechaCreacion - a.fechaCreacion
      )
      .reverse()
      .slice(0, this.NUMERO_FOTOS_POR_CAPA);
    this.imagenesCapaEstructura = this.archivos
      .filter(
        (archivo: ArchivoCoordenada) =>
          archivo.tipo === "imagen" &&
          archivo.keyCatCapa === this.KEY_CAPA_ESTRUCTURA
      )
      .sort(
        (a: ArchivoCoordenada, b: ArchivoCoordenada) =>
          b.fechaCreacion - a.fechaCreacion
      )
      .reverse()
      .slice(0, this.NUMERO_FOTOS_POR_CAPA);
    this.modalActivo = this.modalService.open(this.modalReporteFotografico, {
      centered: true,
      size: "lg",
      windowClass: "modal-ficha-tecnica",
    });

    console.log("meta", this.imagenesCapaMetaActual);
    console.log("completo", this.imagenesCapaCompletado);
  }
}
